<template>
    <div id="home-div">
        <div >
            <h1>{{$t('homeMsg')}}</h1>
            <p>{{$t('homeDesc')}}</p>
        </div>
        <div class="button" id="button-1">
            <div class="circle circle-1"></div>
            <a href="#contact-us">Contact</a>
        </div>
        <div class="button" id="button-2">
            <div class="circle circle-2"></div>
            <a target="_blank" href="https://line.me/ti/g2/J1ihyySmCr457sBn3nojtw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default">Line Open Chat</a>
        </div>
        <div class="update-btn-parent">
            <a href="#update" class="fa fa-arrow-down"></a>
            <img class="deco-down" src="../assets/SVG/deco.svg">
        </div>
    </div>
</template>

<script>

export default {
    name: 'Home',
    
}
</script>

<style scoped>
.update-btn-parent {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: -8px;
}
.fa-arrow-down {
    border: 2px solid white;
    padding: 6px;
    border-radius: 50%;
    
}
.fa-arrow-down:hover {
    color:rgb(211, 218, 226);
}
.deco-down {
    width: 100%;
    margin-top: 20px;
  }
#home-div {
    padding-top: 30vh;
    padding-right: 20%;
    padding-left: 20%;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    color: white;
    height: calc(100% - 84px);
}
@media only screen and (max-height: 600px){
    #home-div {
        padding-top: 15vh;
    }
}
@media only screen and (max-height: 400px){
    #home-div {
        padding-top: 10vh;
    }
}
@media only screen and (max-width: 600px){
    #home-div {
        padding-top: 15vh;
        padding-left: 10%;
        padding-right: 10%;
    }
}
h1 {
    font-size: 48px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    padding-bottom: 20px;
}
@media only screen and (max-width: 1023px){
    #home-div {
        height: calc(100% - 52px);
    }
}
/* Button Styles */

.button {
  background-color: rgba(0,0,0,0);
  display: inline-flex;
  height: 40px;
  width: 150px;
  border: 2px solid #FFF;
  margin: 20px 20px 20px 20px;
  color: #FFF;
  text-transform: uppercase;
  text-decoration: none;
  font-size: .8em;
  letter-spacing: 1.5px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

a {
  color: #FFF;
  text-decoration: none;
  letter-spacing: 1px;
}
    /* Third Button */

.button {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #FFF;
}

#button-2 {
    background: #00b900;
    border: 2px solid #40b940;
}

.button a {
  position: relative;
  transition: all .45s ease-Out;
}

.circle {
  width: 0%;
  height: 0%;
  opacity: 0;
  line-height: 40px;
  border-radius: 50%;
  background: #FFF;
  position: absolute;
  transition: all .5s ease-Out;
  top: 20px;
  left: 70px;
}


.circle-2 {
    background: #3c3;
}

.button:hover .circle {
  width: 200%;
  height: 500%;
  opacity: 1;
  top: -70px;
  left: -70px;
}

#button-1:hover a {
  color: #2D3142;
}
#button-2:hover a {
  color: #FFF;
}
#button-1:hover {
    border: 2px solid #FFF;
}
#button-2:hover {
    border: 2px solid #40b940;
}
</style>